import { render } from "./modalRelationCompetitor.vue?vue&type=template&id=32250eda&scoped=true&ts=true"
import script from "./modalRelationCompetitor.vue?vue&type=script&lang=ts"
export * from "./modalRelationCompetitor.vue?vue&type=script&lang=ts"

import "./modalRelationCompetitor.vue?vue&type=style&index=0&id=32250eda&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32250eda"]])

export default __exports__